<template>
  <div class="mt-4">
    <div class="row pr-3">
      <div class="col-md-9">
        <label class="style-text-config">Seleccionar socio</label>

        <multiselect
          v-model="partner"
          :loading="isLoading"
          :option-height="104"
          :options="getPartnerUsers"
          :searchable="true"
          :show-labels="true"
          placeholder="Seleccione socio"
          track-by="email"
          label="email"
          class="modify-input select-config"
          :allow-empty="true"
        >
          <template #option="props">
            <strong>{{ props.option.name + ' - ' + props.option.email }}</strong>
          </template>
          <template #noResult>
            <div>Sin resultados</div>
          </template>
        </multiselect>
        <div class="col-12 dropdwon-icon">
          <i class="fas fa-chevron-down instructor float-right"></i>
        </div>
      </div>
      <div v-if="partner" class="col-md-9 mt-4">
        <label class="style-text-config">Porcentaje definido al socio</label>
        <base-input
          v-model="partnerPercent"
          placeholder="Porcentaje de ganancias al socio"
          class="partner-input"
          type="number"
        ></base-input>
      </div>
    </div>
    <div :class="partner ? '' : 'mt-4'">
      <base-button
        v-if=" getCurrentCourse && getCurrentCourse.partnerPercent > 0 && getCurrentCourse.partnerPercent !== partnerPercent && partner"
        class="btn-maquillate"
        @click="openDialog = true"
      >
        Guardar cambios
      </base-button>
      <base-button
        v-else
        :loading="isUpdatePartner"
        class="btn-maquillate"
        @click="updateCourse"
      >
        Guardar cambios
      </base-button>
    </div>
    <div>
      <md-dialog
        :md-active="openDialog"
        class="modal-close modalPercentage"
      >
        <span
          class="material-icons close text-right"
          @click="handleCloseDialog"
        >close</span
        >
        <div class="body-modal-course">
          <md-dialog-content class="mt-2">
            <span>{{
                `Estás seguro de cambiar el porcentaje de ${getCurrentCourse ? getCurrentCourse.partnerPercent : 0} ? si lo cambias, los nuevos cálculos serán efectuados con este porcentaje ${partnerPercent} a partir de este momento.`
              }}</span></md-dialog-content
          >

          <md-dialog-actions>
            <md-button
              class="md-button md-primary md-theme-default"
              @click="handleCloseDialog"
            >CANCELAR
            </md-button
            >
            <base-button
              :loading="isUpdatePartner"
              class="btn-maquillate"
              @click="updateCourse"
            >
              CAMBIAR
            </base-button>
          </md-dialog-actions>
        </div>
      </md-dialog>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import {
  FETCH_COURSE, UPDATE_COURSE,
} from '@/store/actions/course';

import Multiselect from 'vue-multiselect';
import { FETCH_PARTNER_USERS } from '@/store/actions/partner';

export default {
  name: 'CourseConfigPartner',

  components: {
    Multiselect,
  },
  data: function() {
    return {
      partner: null,
      partnerPercent: null,
      openDialog: false,
      isLoading: true,
      isUpdatePartner: false,

    };
  },
  computed: {
    ...mapGetters(['getPartnerUsers', 'getCurrentCourse']),

  },
  watch: {
    getCurrentCourse: function(val) {
      this.partner = val.partner;
      this.partnerPercent = val.partnerPercent;
    },

  },
  mounted () {
    this.fetchPartnerUsers();
  },
  methods: {
    async fetchCourse () {
      await this.$store.dispatch(FETCH_COURSE, this.$route.params.id);
    },
    fetchPartnerUsers (
      filter = {
        per_page: 1000,
        order_by: this.descOrder ?? this.sortType,
        search: this.searchValue,
      },
    ) {
      this.$store
        .dispatch(FETCH_PARTNER_USERS, filter)
        .then(() => {
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
          this.notify('danger', 'Tenemos problemas para cargar los usuarios');
        });
    },
    updateCourse () {
      this.isUpdatePartner = true;
      const { partner, partnerPercent } = this;
      const { name } = this.getCurrentCourse;

      this.$store
        .dispatch(UPDATE_COURSE, {
          partner_id: partner ? partner.id : null,
          partner_percent: partner ? parseFloat(partnerPercent) : 0,
          id: this.getCurrentCourse.id,
          name,
        })
        .then(() => {
          this.notify('success', 'Se ha actualizado el socio con éxito');
          this.handleCloseDialog();
          this.fetchCourse();
          this.isUpdatePartner = false;
        })
        .catch(() =>
          this.notify('danger', 'Tenemos problemas para actualizar el curso'),
        );
    },
    handleCloseDialog () {
      this.openDialog = false;
    },
    notify (type, message) {
      this.$notify({
        type: type,
        verticalAlign: 'top',
        horizontalAlign: 'right',
        message: message,
      });
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.course-url-col {
  display: flex;
  align-items: center;
  flex-direction: row;
}

.course-slug {
  margin: 0 0 0 10px;
}

.course-slug .form-group {
  margin: 0;
}

.course-image {
  width: auto;
  height: auto;
  object-fit: cover;
}

.course-image-container {
  padding: 15px 20px;
  width: 100%;
}

.course-image-container > img {
  width: 100%;
}

.custom-radio .custom-control-input ~ .custom-control-label {
  padding-top: 1px;
}

.ql-container {
  height: 40vh;
}

.ql-toolbar.ql-snow + .ql-container.ql-snow {
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
}

.ql-editor:hover {
  box-shadow: none;
}

.col-md-9 .form-group input,
.input-usd {
  padding: 6px;
  padding-left: 12px !important;
  width: 100% !important;
}

.custom-file-label::after {
  background-color: #b7227e !important;
  color: white !important;
  border: 1px solid #b7227e !important;
  border-radius: 0 !important;
}

.base-radio {
  color: #000;
}

.style-text-config {
  font-size: 15px;
  color: #000;
  font-weight: 700;
  text-transform: uppercase;
  margin-bottom: 1rem;
}

.ql-editor {
  box-shadow: none !important;
  border-top: 1px solid #dee2e6;
}

.custom-radio .custom-control-input:checked ~ .custom-control-label::after,
.custom-radio .custom-control-input:checked ~ .custom-control-label::before {
  background: #000;
  border-radius: 50%;
}

.dropdwon-icon {
  margin-top: -34px;
}

.dropdwon-icon i {
  padding: 6px;
  background: white;
  margin-right: -5px;
}

.select-config >>> .multiselect__select:before,
.multiselect__select:before {
  border: none;
  font-size: 16px !important;
}

.select-config >>> .multiselect__select {
  transition: none;
  transform: scale(1);
}

.select-config >>> .multiselect__tag {
  line-height: 20px !important;
  background-color: #b7227e;
  margin-top: 5px;
  display: flex;
  align-items: center;
}

.select-config >>> .multiselect__tag .multiselect__tag-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}

.select-config >>> .multiselect__tag .multiselect__tag-icon:after {
  color: white;

}

.select-config >>> .multiselect__tag .multiselect__tag-icon:hover {
  color: white;
  background-color: #b7227e;
}

.main-container__librery input.multiselect__input {
  padding-left: 0px;
  border: none !important;
}

.alert-notify {
  display: -webkit-box !important;
  display: -ms-flexbox !important;
  display: flex !important;
  max-width: 600px;
  width: calc(100% - 30px);
  padding-right: 80px;
  color: rgba(255, 255, 255, 0.85);
}

.name-course-input input {
  width: 100% !important;
  padding-left: 10px !important;
}

.loading-course-detail {
  color: black;
}

.select-config >>> .multiselect__option--highlight {
  background: black;
  outline: none;
  color: #fff;
}

.select-config >>> .multiselect__option--highlight::after {
  background: black;
  outline: none;
  color: #000;
}

.select-status {
  height: 52px;
}

.select-config >>> .multiselect--active .multiselect__select {
  -webkit-transform: none;
  transform: none;
}

.select-config >>> .multiselect__select::before {
  top: 35%;
}

.select-config >>> .multiselect__single {
  padding: 0px !important;
  margin-top: 10px !important;
  margin-bottom: 10px !important;
  line-height: 30px;
  font-size: 16px;
  letter-spacing: 0.01em;
}

.select-config >>> .multiselect__placeholder {
  padding-top: 0px !important;
  margin-top: 10px;
  margin-bottom: 10px;
  line-height: 30px;
  font-size: 16px;
  letter-spacing: 0.01em;
}

.select-config >>> .multiselect__tags {
  height: 52px;
  padding: 0px 40px 0px 13px !important;
  display: flex;
}

.select-config >>> .multiselect__input,
.multiselect__tag {
  margin-top: 10px !important;
  margin-bottom: 10px !important;
  line-height: 20px !important;
  border:none!important;
}

.select-config >>> .multiselect__input {
  padding: 0px !important;
  margin-top: 10px !important;
  margin-bottom: 10px !important;
  font-size: 16px;
  letter-spacing: 0.01em;
  line-height: 30px;
}

.select-config >>> .multiselect__select {
  height: 50px;
  width: 50px;
  margin-top: 0px !important;
  padding: 0px !important;
}

.main-container__librery input {
  background-color: #fff;
  border-radius: 3px;
}

.select-status {
  padding: 0px 10px 0px 10px !important;
  font-size: 16px !important;
}

.details-select {
  height: 30px !important;
  width: 40px !important;
  padding: 0px !important;
  margin-top: 10px !important;
  position: absolute;
  top: 50%;
  right: 0%;
  transform: translate(-50%, -50%);
  background: white;
  padding: 10px;
  font-size: 14px;
  text-align: center;
}

.fa-chevron-down:before {
  margin-top: 15px;
  font-size: 16px;
  margin-right: 5px;
}

.select-config >>> .multiselect__select::before {
  top: 35% !important;
}

.select-config >>> .main-container__librery .border-name input {
  border: 1px solid #ddd !important;
}

.select-config >>> .multiselect__tag .multiselect__tag-icon:after {
  display: flex;
  justify-content: center;
  align-items: center;
  //top: 10%;
  //right: 30%;
}

.select-config >>> .multiselect__content-wrapper {
  top: 100% !important;
  bottom: auto !important;
}

.select-config >>> .multiselect__option--selected {
  background: #b5016d !important;
  color: #fff !important;
  font-weight: 500 !important;
}

.select-config >>> .multiselect--above .multiselect__content-wrapper {
  top: 100% !important;
  bottom: auto !important;
}

.option_trailer_video {
  display: flex !important;
}

.option__image {
  height: 50px !important;
}

.option__title {
  padding-left: 10px;

}

.option__desc {
  padding: 5px 0;
}

.select-config >>> .multiselect__option {
  display: flex;
}

.select-config >>> .multiselect__option.multiselect__option--highlight::after {
  background-color: transparent !important;
}
</style>
